import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopType from "@/enum/ShopType";
import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import ShopDTO from "@/dto/shop/ShopDTO";
import { isConsolidatedShippingOrder } from "@/utils/OrderTagUtils";

const onlyShowTipShopTypes = [
    ShopType.PINDUODUO,
    ShopType.PDD_DROP_SHIPPING_SUPPLIER,
    ShopType.PDD_FDS,
    ShopType.PDD_FULFILLMENT,
];

interface PddConsolidatedShippingProps {
    order: OrderDTO;

    shop: ShopDTO;
}

export function shouldRenderPddConsolidatedShipping(order: OrderDTO, shop: ShopDTO) {
    return onlyShowTipShopTypes.includes(shop.type) && !!isConsolidatedShippingOrder(order);
}

const PddConsolidatedShipping: React.FC<PddConsolidatedShippingProps> = function (props) {
    const { order, shop } = props;

    if (!shouldRenderPddConsolidatedShipping(order, shop)) {
        return null;
    }

    // 目前只有拼多多集运显示这个提示
    return (
        <Tooltip title="拼多多官方规则，相同集运的集运订单才支持合并订单">
            <div style={{ color: "rgb(51, 51, 51)", borderBottom: "1px dashed rgb(170, 170, 170)" }}>
                收件人地址及电话均为集运仓地址及联系电话，若您需要查看消费者信息，请您前往拼多多商家后台进行查看。
            </div>
        </Tooltip>
    );
};

export default observer(PddConsolidatedShipping);
